export default "https://cdn-static.gokick.com/assets/33ce344a4b715ce65918e7685bcdda5ecb423fac/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";